import {
  BROADCAST_KNOCK_MEETING,
  BROADCAST_KNOCK_MEETING_ASYNC,
  BROADCAST_LEAVE_MEETING,
  BROADCAST_KNOCK_REJECTED
} from 'actions/Types';

function knock(state = null, action) {
  if (
    [
      BROADCAST_KNOCK_MEETING,
      `${BROADCAST_KNOCK_MEETING_ASYNC}_SUCCESS`
    ].includes(action.type)
  ) {
    return { ...action.payload, rejected: false, errored: false };
  }

  if (action.type === `${BROADCAST_KNOCK_REJECTED}`) {
    return { rejected: true };
  }

  if (action.type === `${BROADCAST_LEAVE_MEETING}`) {
    return null;
  }

  if (
    [
      `${BROADCAST_KNOCK_MEETING}_FAILURE`,
      `${BROADCAST_KNOCK_MEETING_ASYNC}_FAILURE`
    ].includes(action.type)
  ) {
    return { errored: true };
  }
  return state;
}

export default knock;
